function sliderForBlog() {
  var checkWidth = $(window).width();
  var owlPost = $("#blog_slider");
  // var mobFeature = $("#mob_features");
  // if (checkWidth > 991) {
  //   if (typeof owlPost.data('owl.carousel') != 'undefined' & mobFeature.data('owl.carousel') != 'undefined') {
  //     owlPost.data('owl.carousel').destroy();
  //     mobFeature.data('owl.carousel').destroy();
  //   }
  //   owlPost.removeClass('owl-carousel');
  //   mobFeature.removeClass('owl-carousel');
  // } else if (checkWidth < 992) {
  //   owlPost.addClass('owl-carousel');
  //   mobFeature.addClass('owl-carousel');
  //   owlPost.owlCarousel({
  //     slideSpeed : 300,
  //     paginationSpeed : 400,
  //     singleItem:true,
  //     loop:true,
  //     items:3.2,
  //     nav:false,
  //     dots:false,
  //     center:true,
  //     responsiveClass:true,
  //     responsive : {
  //        0: {
  //         items:1
  //       },
  //       // breakpoint from 480 up
  //       600 : {
  //         items:1
  //       },
  //       // breakpoint from 768 up
  //       1000 : {
  //         items:3.2
  //       }
  //     }
  //   });
  //   mobFeature.owlCarousel({
  //     slideSpeed : 300,
  //     paginationSpeed : 400,
  //     singleItem:true,
  //     items:2,
  //     nav:true,
  //     dots:false,
  //     loop:true,
  //     responsiveClass:true,
  //     responsive : {
  //       0 : {
  //         items:1
  //       },
  //       // breakpoint from 768 up
  //       768 : {
  //         items:2
  //       }
  //     }
  //   });
  // }
}
$(document).ready(function(){
  $('.imagezoom').zoom();
  // $("#owl-demo").owlCarousel({
  //   slideSpeed : 300,
  //   paginationSpeed : 400,
  //   autoplay:false,
  //   singleItem:true,
  //   loop:false,
  //   nav:true,
  //   items:1,
  //   dots:false
  // });

  $("#owl-demo-review").owlCarousel({
    slideSpeed : 1000,
    paginationSpeed : 1000,
    autoplayTimeout:1000,
    singleItem:true,
    loop:true,
    nav:true,
    dots:false,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:3,
            nav:false
        },
        1000:{
            items:3,
            nav:true,
            loop:false
        }
    }
  });
  
  $('#home_collection').owlCarousel({
    loop:true,
    margin:50,
    nav:true,
    dots:false,
    responsive:{
      0:{
        items:1
      },
      768:{
        items:2
      },
      1000:{
        items:3
      }
    }
  });

  $('.related_product_slider').owlCarousel({
    loop:false,
    margin:50,
    nav:true,
    dots:false,    
    responsive:{
      0:{
        items:1
      },
      768:{
        items:2
      },
      1000:{
        items:3
      }
    }
  });
  
  $('.feature-image-slider').owlCarousel({
    loop:true,
    margin:50,
    nav:true,
    dots:false,
    items:1,
    autoHeight: true,
  });
  
  $('.nav-main-slider').owlCarousel({
    loop:true,
    margin:15,
    nav:true,
    dots:false, 
    items:5
  });
  
  $('.product-images .nav-product-image').click(function(){
    var dataIndex = $(this).attr('data-index')
    $('.product-images .feature-image-slider ').trigger('to.owl.carousel', dataIndex)
  });
  
  
  $('.more-btn').click(function()
                       {
    $('.more-buy-online').show();
    $('.more').hide();
    $('.less-hide').show();
  });
  $('.less-btn').click(function()
                       {
    $('.more-buy-online').hide();
    $('.less-hide').hide();
    $('.more').show();
  });
//
  sliderForBlog();
  $(window).resize(sliderForBlog);
  var cdkscreensize = $(window).width();
  console.log(cdkscreensize)
  
  if(cdkscreensize < 991){
    $('.dropdown_menu').click(function(e){
      e.preventDefault();
      $(this).next('.sub_menu').toggleClass('menuActive');
    });
  }
  
  $(document).on('click', '#forgottPassWord', function(){
    $('#loginMainForm').hide();
    $('#RecoverPasswordForm').show();
  })
  
  $(document).on('click', '#cancleforgottPassWord', function(){
    $('#RecoverPasswordForm').hide();
    $('#loginMainForm').show();
  })
  //
  
  $('.navbar-toggler').click(function() {
    var headerHeight = $('.subheader').outerHeight();
    
    $('.navbar-collapse').css('margin-top', headerHeight);
    $('.navbar-collapse').css('padding-top', headerHeight);
    $('.navbar-collapse ul').toggleClass('active');
    
    $(this).toggleClass('active');
  });
  
  $('.dropdown_menu').click(function() {
    $(this).toggleClass('open');
  });
  
  // mobile menu slide from the left
  $('[data-toggle="slide-collapse"]').on('click', function() {
    $navMenuCont = $($(this).data('target'));
    $navMenuCont.animate({'width':'toggle'}, 350);
  });
  
  if($('.table-responsive-xl').length > 0){
    var tableWidth = $('.table-responsive-xl table').width();
    
    $('.wrapper1 .div1').css('width', tableWidth);
  }
  
  $(function(){
    $(".wrapper1").scroll(function(){
      $(".table-responsive-xl").scrollLeft($(".wrapper1").scrollLeft());
    });
    $(".table-responsive-xl").scroll(function(){
      $(".wrapper1").scrollLeft($(".table-responsive-xl").scrollLeft());
    });
  });
});
